import { render, staticRenderFns } from "./updtadd.vue?vue&type=template&id=447b7d47&scoped=true&"
import script from "./updtadd.vue?vue&type=script&lang=js&"
export * from "./updtadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447b7d47",
  null
  
)

export default component.exports